import { DateRangeSelectorField } from '@app/components/date-range-selector/date-range/DateRangeSelectorField';
import { StationsAdvancedFilterField } from '@app/components/stations/advanced-filter/form/StationsAdvancedFilterField';
import { useStations } from '@app/core/stations/hooks/useStations';
import { useStationsGroups } from '@app/core/stations/hooks/useStationsGroupsQuery';
import { Box } from '@mui/material';
import { DateTime } from 'luxon';
import { defineMessage, useIntl } from 'react-intl';
import { StreamQualityReportValues } from './types';

const dateRangeLabelMessage = defineMessage({
  id: 'logger.reports.streamQuality.form.dateRangeLabel',
  defaultMessage: 'Rango de fechas',
});

const stationsLabelMessage = defineMessage({
  id: 'logger.reports.streamQuality.form.stationsLabel',
  defaultMessage: 'Emisoras',
});

const allStationsPlaceholderMessage = defineMessage({
  id: 'logger.reports.streamQuality.form.stationsPlaceholder',
  defaultMessage: 'Todas las emisoras',
});

/**
 * Stream quality report filters: preset date range and advanced station filter.
 */
export function StreamQualityReportForm() {
  const { $t } = useIntl();
  const stations = useStations();
  const stationGroups = useStationsGroups();

  return (
    <Box sx={{ display: 'flex', gap: 1.5 }}>
      <Box sx={{ minWidth: 220 }}>
        <DateRangeSelectorField
          name="dateRange"
          minDate={DateTime.now().minus({ days: 30 }).toJSDate()}
          maxDate={DateTime.now().toJSDate()}
        />
      </Box>
      <StationsAdvancedFilterField<StreamQualityReportValues, 'stationsFilter'>
        name="stationsFilter"
        label=""
        placeholder={$t(allStationsPlaceholderMessage)}
        stations={stations}
        stationGroups={stationGroups}
        size="small"
      />
    </Box>
  );
}
